import { State } from 'reducers/State';
import { CommentToSnippet } from 'reducers/CommentHistory/Snippets';

export const commentToSnippetSelector = (state: State): CommentToSnippet => {
  return state.commentHistory.snippets.commentToSnippet;
};
